<input nz-input [placeholder]="placeholder" [formControl]="control" [nzAutocomplete]="auto" />
<nz-autocomplete #auto nzBackfill>
  <nz-auto-option *ngFor="let option of options$ | async" [nzValue]="isObjectArray ? option.value : option">
    {{ isObjectArray ? option.label : option }}
  </nz-auto-option>
</nz-autocomplete>
